// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start()
require("turbolinks").start()
require("bootstrap/dist/js/bootstrap.bundle.min")
require("admin-lte/dist/js/adminlte.min")

import '../stylesheets/application.scss'
import '../javascripts/popover.js'
import '../javascripts/parts_order.js'
import '../javascripts/robot_part_type_form.js'
import '../javascripts/production_line_form.js'
import '../javascripts/robot_form.js'
import '../javascripts/model.js'
import '../javascripts/working_lines/externalLink.js'
import '../javascripts/working_lines/production-line-selectbox.js'
import '../javascripts/working_lines/factory-id-selectbox.js'

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
